import staticData from "@/public/data/flight/results.json";
import Flex from "@/shared/components/common/Flex";
import Typography from "@/shared/components/common/Typography";

interface FlightCardPriceInfoProps {
  price?: number | null;
}

export default function FlightCardPriceInfo({
  price,
}: FlightCardPriceInfoProps) {
  const { currencyLabel } = staticData.resultCard;

  return (
    <Flex gap={"1"} alignItems={"center"} className="px-3">
      <Typography
        variant={"body1"}
        className="text-md md:text-lg text-primary font-semibold"
      >
        {price?.toLocaleString()}
      </Typography>

      <Typography variant={"body1"} className="text-primary font-semibold">
        {currencyLabel}
      </Typography>
    </Flex>
  );
}
